import './index.scss'
if ( window.innerWidth> 768)  {
    const perRow = 3;
    const $items = $(".section2 ul li");
    const $mask = $(".fade-mask");
    let visibleRows = 0;

    // ✅ IntersectionObserver
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
        if (entry.isIntersecting) {
            $(entry.target).addClass("show");
            observer.unobserve(entry.target);
        }
        });
    }, {
        threshold: 0.5
    });

    // ✅ 给每个 li 设置方向
    $items.each(function (index) {
        let rowIndex = Math.floor(index / perRow);

        if (rowIndex % 2 === 0) {
        $(this).addClass("left-enter");
        } else {
        $(this).addClass("right-enter");
        }
    });

    // ✅ 显示行
   function showRows(rowCount) {
        let start = visibleRows * perRow;
        let end = (visibleRows + rowCount) * perRow;

        for (let i = start; i < end && i < $items.length; i++) {
            let el = $items.eq(i);
            el.show();
            observer.observe(el[0]);
        }

        visibleRows += rowCount;

        // ✅ 判断是否加载完
        if (visibleRows * perRow >= $items.length) {
            $("#loadMore").hide();     // 隐藏按钮
            $mask.addClass("hide");    // 隐藏渐变遮罩
        }
    }

    // ✅ 初始显示4行
    showRows(4);

    // ✅ 点击加载2行
    $("#loadMore").click(function () {
        showRows(2);
    });
}


$(".section3 ul li").hover(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".section3 .text div").eq(index).addClass("active").siblings().removeClass("active");
},function() {
    $(".section3 ul li").removeClass("active");
    $(".section3 .text div").removeClass("active");
})